export function asMillis(x) {
  if (!x) return null;
  if (typeof x === "number") return x;
  if (typeof x.toMillis === "function") return x.toMillis();
  return null;
}
export function joinWithAnd(arr) {
  if (arr.length <= 1) return arr[0] || "";
  if (arr.length === 2) return `${arr[0]} and ${arr[1]}`;
  return `${arr.slice(0, -1).join(", ")}, and ${arr[arr.length - 1]}`;
}
export function assetUrlFromEntryImage(asset) {
  const url = asset?.fields?.file?.url;
  if (!url) return null;
  return url.startsWith("http") ? url : `https:${url}`;
}
